/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable indent */
/* eslint-disable operator-linebreak */
/* eslint-disable import/prefer-default-export */

import type { EbookBookTemplateValues } from '@orientaction/types';
import { AppThunk } from '../store';

export const updateField =
  (field: keyof EbookBookTemplateValues | string, value: any): AppThunk =>
  (dispatch) => {
    dispatch({
      type: 'UPDATE_FIELD_EBOOK',
      payload: { field, value },
    });
  };

export const resetValuesEbooks = (): AppThunk => (dispatch) => {
  dispatch({
    type: 'RESET_VALUES_EBOOK',
  });
};

export const setAllValues =
  (payload: Partial<EbookBookTemplateValues>): AppThunk =>
  (dispatch) => {
    dispatch({
      type: 'SET_ALL_VALUES_EBOOK',
      payload,
    });
  };
